function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { twMerge } from "@stereoagency/tailwind-config";
import React from "react";
import { genericComponentFactory } from "../../utils";
var cxFactory = function(param) {
    var _param_variant = param.variant, variant = _param_variant === void 0 ? "h4" : _param_variant, className = param.className;
    return twMerge("font-heading font-semibold", variant === "h1" && "text-heading-h1-base leading-xtight tracking-tight sm:text-heading-h1-tablet lg:text-heading-h1-desktop", variant === "h2" && "text-heading-h2-base leading-snug tracking-tight md:text-heading-h2-desktop", variant === "h3" && "text-heading-h3-base leading-snug tracking-normal md:text-heading-h3-desktop", variant === "h4" && "text-heading-h4-base tracking-normal leading-snug", className);
};
var headingRenderer = function(_param, ref) /*#__PURE__*/ {
    var tmp = _param.as, As = tmp === void 0 ? "h1" : tmp, className = _param.className, children = _param.children, variant = _param.variant, props = _object_without_properties(_param, [
        "as",
        "className",
        "children",
        "variant"
    ]);
    return React.createElement(As, _object_spread({
        ref: ref,
        className: cxFactory({
            variant: variant,
            className: className
        })
    }, props), children);
};
var Heading = genericComponentFactory({
    h1: headingRenderer,
    h2: headingRenderer,
    h3: headingRenderer,
    h4: headingRenderer,
    h5: headingRenderer,
    div: function(_param, ref) /*#__PURE__*/ {
        var variant = _param.variant, children = _param.children, className = _param.className, props = _object_without_properties(_param, [
            "variant",
            "children",
            "className"
        ]);
        return React.createElement("div", _object_spread({
            ref: ref,
            className: cxFactory({
                variant: variant,
                className: className
            })
        }, props), children);
    },
    span: function(_param, ref) /*#__PURE__*/ {
        var variant = _param.variant, children = _param.children, className = _param.className, props = _object_without_properties(_param, [
            "variant",
            "children",
            "className"
        ]);
        return React.createElement("span", _object_spread({
            ref: ref,
            className: cxFactory({
                variant: variant,
                className: className
            })
        }, props), children);
    }
}, "div");
export default Heading;

//# sourceMappingURL=Heading.js.map